import { ILocation } from "../Interfaces/index";

export class Location implements ILocation {
  id: number;
  name: string;
}
